import {AccountTypeEntityModel} from "../../account-type-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";
import {AccountTypeData} from "../../account-type.data";

@Component({
    selector: "wbo-account-type-edit-details",
    templateUrl: "./account-type-edit-details.component.html"
})
export class AccountTypeEditDetailsComponent {
    AccountTypeData = AccountTypeData;

    constructor(public model: AccountTypeEntityModel, public editService: EditService) {
    }

    onChangeAccountType(): void {
        if (this.model.data.accountingType === AccountTypeData.OUTGOINGS) {
            this.model.data.splitTender = false;
            this.model.data.invoicePrintCount = undefined;
        }
        if (this.model.data.accountingType === AccountTypeData.VOUCHER) {
            this.model.data.multipleContacts = false;
        }
        if (this.model.data.accountingType == AccountTypeData.DEBTOR || this.model.data.accountingType === AccountTypeData.VOUCHER) {
            this.model.data.limitDuration = false;
        }
    }

    onChangeAccountLimited(): void {
        if (!this.model.data.accountLimited && this.model.data.limitDuration) {
            this.model.data.limitDuration = false;
        }
    }

    get isCreditLimitReadonly(): boolean {
        return !this.model.data.accountLimited ||
            (this.model.data.accountingType === AccountTypeData.VOUCHER || this.model.data.accountingType === AccountTypeData.DEBTOR);
    }

    get isOutgoingDenominationsVisible(): boolean {
        return this.model.data.accountingType === AccountTypeData.OUTGOINGS;
    }

}
